import { Component, ContentChild, Input, OnInit, signal } from '@angular/core';

@Component({
	selector: 'tvcore-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
	standalone: false,
})
export class FooterComponent implements OnInit {
	@Input()
	logo: string;
	@Input()
	logoAlt: string;

	@ContentChild('boldText')
	boldText: any;

	showCookieSettings = signal(false);

	get cookiehub(): any {
		return (window as any).cookiehub;
	}

	ngOnInit() {
		if (this.cookiehub) {
			this.showCookieSettings.set(true);
		}
	}

	openCookieSettings() {
		this.cookiehub.openSettings();
	}
}
